import * as React from 'react';
export {
  FormattedDate,
  FormattedTime,
  FormattedRelativeTime,
  FormattedNumber,
  FormattedPlural,
  FormattedMessage,
  FormattedHTMLMessage,
} from 'react-intl';
import { FormattedDate } from 'react-intl';

export interface FormattedDateTimeProps extends React.ComponentProps<typeof FormattedDate> {
  children: React.ReactNode | ((val: Intl.DateTimeFormatPart[]) => React.ReactNode);
}

export const FormattedDateTime: React.FC<FormattedDateTimeProps> = ({ children, ...rest }) => (
  <FormattedDate
    year="numeric"
    month="numeric"
    day="numeric"
    hour="numeric"
    minute="numeric"
    {...rest}
  >
    {children}
  </FormattedDate>
);
